/* ============
 * Job Modal Store
 * ============
 */

import { defineStore } from 'pinia';
import './pinia';

export const useJobModalStore = defineStore('jobModal', {
  state: () => ({
    visible: false,
    job: null,
    // Was `open` under Vuex. Pinia merges state, getters and actions into a
    // single namespace, so it would have collided with the `open()` action.
    expanded: true,
  }),

  actions: {
    open(data) {
      this.visible = true;
      this.job = data.job;
    },

    close() {
      this.visible = false;
      this.job = null;
    },
  },
});

export default useJobModalStore;
